
import * as React from "react";
import { FeedbackCreator } from "./FeedbackCreator";

export const Api = () => <FeedbackCreator header="Please let us know how you plan to utilize our API and the number of
requests you anticipate sending. This will help us ensure best quality
of service for you." alertContent="Application for Api was successfully send." type="API" textFieldLabel="Request API access"/>